export default class NotificationsController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmiter = EventEmitter;
    }
}



// WEBPACK FOOTER //
// ./app/components/notifications/notifications.controller.js